<template>
  <v-dialog v-model="dialog" width="300">
    <v-card>
      <v-card-title class="headline pa-5 pb-3 dialog_title" style="justify-content: center;">
        <h4>{{ title }}</h4>
      </v-card-title>
      <v-card-text class="pa-5 pt-2 pb-3 dialog_text text-center">{{ message }}</v-card-text>
      <v-card-actions class="pa-5">
        <v-spacer></v-spacer>
        <v-btn class="dialog_btn" color="primary" outlined text @click="confirmAction">완료</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
    title: String,
    message: String,
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    confirmAction() {
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Pretendard-Regular', sans-serif;
}

.dialog_title {
  justify-content: center;
}

.dialog_text {
  text-align: center;
}

.dialog_btn {
  width: 100%;
}
</style>